// Patient overview section questionnaire constants
export enum PatientOverviewQuestionnaireItem {
  PATIENT_OVERVIEW_LEGAL_NAME = 'patient-overview/legal-name',
  PATIENT_OVERVIEW_PREFERRED_NAME = 'patient-overview/preferred-name',
  PATIENT_OVERVIEW_DATE_OF_BIRTH = 'patient-overview/date-of-birth',
  PATIENT_OVERVIEW_ADDRESS = 'patient-overview/address',
  PATIENT_OVERVIEW_GENDER = 'patient-overview/gender',
  PATIENT_OVERVIEW_SEX = 'patient-overview/sex',
  PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID = 'patient-overview/medicaid-id',
  PATIENT_OVERVIEW_ORDERING_PRACTITIONER = 'patient-overview/ordering-practitioner',
  PATIENT_OVERVIEW_DISCHARGE_ASSESSMENT_STATUS = 'patient-overview/discharge-assessment-status'
}
